<template>
  <v-app>
    <TheHeader></TheHeader>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import TheHeader from "./components/Layout/TheHeader.vue";
//import { Storage } from "@capacitor/storage";
export default {
  name: "App",
  components: {
    TheHeader,
  },

  // mounted() {
  //   window.onload = this.resetTimer();
  //   document.onmousemove = this.resetTimer();
  //   document.onkeydown = this.resetTimer();
  //   Storage.get({ key: "compte" }).then((response) => {
  //     if (response.value !== null) {
  //       const result = JSON.parse(response.value);
  //       if (this.$store.state.token) {
  //         this.$store.dispatch("set_Compte", {
  //           userName: result.compte,
  //           passWord: result.motPass,
  //         });
  //       } else {
  //         this.$router.push("/");
  //       }
  //     } else {
  //       this.$router.push("/");
  //     }
  //   });
  // },
  // methods: {
  //   resetTimer() {
  //     console.log("resetTimer");
  //     var time;
  //     clearTimeout(time);
  //     time = setTimeout(this.logout, 7000);
  //     // 1000 milliseconds = 1 second
  //   },
  //   logout() {
  //     console.log("testttt");
  //     //this.$router.push("/");
  //     this.$store.dispatch("set_token", null);
  //   },
  // },
};
</script>
